import { render } from "./TheHeader.vue?vue&type=template&id=7951e9d0"
import script from "./TheHeader.vue?vue&type=script&lang=ts"
export * from "./TheHeader.vue?vue&type=script&lang=ts"

import "./TheHeader.scss?vue&type=style&index=0&lang=scss"
const cssModules = script.__cssModules = {}
import style1 from "./TheHeader.vue?vue&type=style&index=1&id=7951e9d0&lang=scss&module=true"
cssModules["$style"] = style1
script.render = render

export default script